import axios from 'axios';
import Vue from 'vue'



export default {
    get (cartId) {
        return axios.get('/api/cart/get', { params: {cartId: cartId} })
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    add (cartId, lines) {
        return axios.post('/api/cart/add', { cartId: cartId, lines: lines})
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deliveryModeToCart (cartId, deliveryModeId) {
        return axios.post('/api/cart/set-delivery-mode', { cartId: cartId, deliveryModeId: deliveryModeId})
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    remove (cartId, itemVariantId) {
        return axios.post('/api/cart/remove', { cartId: cartId, itemVariantId:itemVariantId})
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    //delivery modes
    getDeliveryModes () {
        return axios.get('/api/cart/delivery-modes')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    validationGiftCardCode(setGiftCardToCartRequest){
        return axios.post('/api/cart/set-gift-card' , setGiftCardToCartRequest)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}